import { adfetch, fileDownloadHeaders } from "@api/fetch";

export function downloadFile(url: string, fileName: string) {
  return adfetch(url, {
    method: "get",
    headers: fileDownloadHeaders,
    credentials: "include"
  })
    .then((res) => res.blob())
    .then((blob) => processDownloaded(blob, fileName));
}

export function downloadViaNewTab(url: string) {
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.click();
}

export function processDownloaded(blob: Blob, fileName: string) {
  const downloadUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = downloadUrl;
  a.download = fileName;
  a.click();
}

export function processViewInNewTab(blob: Blob) {
  const downloadUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = downloadUrl;
  a.target = "_blank";
  a.click();
}

export function downloadFile1(url: string, defaultFileName?: string) {
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  // a.download = filename;
  a.click();
}
